/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { JobConfigurationDtoTargetSystem } from './JobConfigurationDtoTargetSystem';
import {
    JobConfigurationDtoTargetSystemFromJSON,
    JobConfigurationDtoTargetSystemFromJSONTyped,
    JobConfigurationDtoTargetSystemToJSON,
} from './JobConfigurationDtoTargetSystem';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RoleCatalogDto } from './RoleCatalogDto';
import {
    RoleCatalogDtoFromJSON,
    RoleCatalogDtoFromJSONTyped,
    RoleCatalogDtoToJSON,
} from './RoleCatalogDto';
import type { DueState } from './DueState';
import {
    DueStateFromJSON,
    DueStateFromJSONTyped,
    DueStateToJSON,
} from './DueState';
import type { JobFrequency } from './JobFrequency';
import {
    JobFrequencyFromJSON,
    JobFrequencyFromJSONTyped,
    JobFrequencyToJSON,
} from './JobFrequency';
import type { JobState } from './JobState';
import {
    JobStateFromJSON,
    JobStateFromJSONTyped,
    JobStateToJSON,
} from './JobState';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { JobOccurrenceCatalogDtoWorkProgressSummary } from './JobOccurrenceCatalogDtoWorkProgressSummary';
import {
    JobOccurrenceCatalogDtoWorkProgressSummaryFromJSON,
    JobOccurrenceCatalogDtoWorkProgressSummaryFromJSONTyped,
    JobOccurrenceCatalogDtoWorkProgressSummaryToJSON,
} from './JobOccurrenceCatalogDtoWorkProgressSummary';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';

/**
 * 
 * @export
 * @interface JobOccurrenceCatalogDto
 */
export interface JobOccurrenceCatalogDto {
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceCatalogDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceCatalogDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceCatalogDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceCatalogDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceCatalogDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof JobOccurrenceCatalogDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceCatalogDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceCatalogDto
     */
    lastModifierUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof JobOccurrenceCatalogDto
     */
    editingUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceCatalogDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {JobState}
     * @memberof JobOccurrenceCatalogDto
     */
    state?: JobState;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    jobConfigurationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    jobConfigurationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    jobConfigurationIuid?: string | null;
    /**
     * 
     * @type {JobFrequency}
     * @memberof JobOccurrenceCatalogDto
     */
    frequency?: JobFrequency;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceCatalogDto
     */
    assignedUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceCatalogDto
     */
    assignedRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    assignedUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    assignedRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOccurrenceCatalogDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceCatalogDto
     */
    reviewRequired?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceCatalogDto
     */
    reviewUserIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof JobOccurrenceCatalogDto
     */
    reviewRoleIds?: Array<number> | null;
    /**
     * 
     * @type {Array<UserCatalogDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    reviewUsers?: Array<UserCatalogDto> | null;
    /**
     * 
     * @type {Array<RoleCatalogDto>}
     * @memberof JobOccurrenceCatalogDto
     */
    reviewRoles?: Array<RoleCatalogDto> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOccurrenceCatalogDto
     */
    reviewRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceCatalogDto
     */
    autoApprove?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceCatalogDto
     */
    wasAutoApproved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    approvalTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof JobOccurrenceCatalogDto
     */
    approverUserId?: number | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof JobOccurrenceCatalogDto
     */
    approverUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    targetSystemId?: string | null;
    /**
     * 
     * @type {JobConfigurationDtoTargetSystem}
     * @memberof JobOccurrenceCatalogDto
     */
    targetSystem?: JobConfigurationDtoTargetSystem | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    end?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    timeZone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JobOccurrenceCatalogDto
     */
    executionAllDay?: boolean;
    /**
     * 
     * @type {DueState}
     * @memberof JobOccurrenceCatalogDto
     */
    dueState?: DueState;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    executionStarted?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    executionCompleted?: string | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof JobOccurrenceCatalogDto
     */
    executionCompletedByUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    executionStateChangedTime?: string | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof JobOccurrenceCatalogDto
     */
    executionStateChangedUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {JobOccurrenceCatalogDtoWorkProgressSummary}
     * @memberof JobOccurrenceCatalogDto
     */
    workProgressSummary?: JobOccurrenceCatalogDtoWorkProgressSummary | null;
    /**
     * 
     * @type {string}
     * @memberof JobOccurrenceCatalogDto
     */
    $type?: JobOccurrenceCatalogDtoTypeEnum;
}


/**
 * @export
 */
export const JobOccurrenceCatalogDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoJobOccurrenceCatalogDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.JobOccurrenceCatalogDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type JobOccurrenceCatalogDtoTypeEnum = typeof JobOccurrenceCatalogDtoTypeEnum[keyof typeof JobOccurrenceCatalogDtoTypeEnum];



/**
 * Check if a given object implements the JobOccurrenceCatalogDto interface.
 */
export function instanceOfJobOccurrenceCatalogDto(value?: unknown): value is JobOccurrenceCatalogDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(JobOccurrenceCatalogDtoTypeEnum)[0];
}

export function JobOccurrenceCatalogDtoFromJSON(json: any): JobOccurrenceCatalogDto {
    return JobOccurrenceCatalogDtoFromJSONTyped(json, false);
}

export function JobOccurrenceCatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobOccurrenceCatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : JobStateFromJSON(json['state']),
        'jobConfigurationId': json['jobConfigurationId'] == null ? undefined : json['jobConfigurationId'],
        'jobConfigurationName': json['jobConfigurationName'] == null ? undefined : json['jobConfigurationName'],
        'jobConfigurationIuid': json['jobConfigurationIuid'] == null ? undefined : json['jobConfigurationIuid'],
        'frequency': json['frequency'] == null ? undefined : JobFrequencyFromJSON(json['frequency']),
        'assignedUserIds': json['assignedUserIds'] == null ? undefined : json['assignedUserIds'],
        'assignedRoleIds': json['assignedRoleIds'] == null ? undefined : json['assignedRoleIds'],
        'assignedUsers': json['assignedUsers'] == null ? undefined : ((json['assignedUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'assignedRoles': json['assignedRoles'] == null ? undefined : ((json['assignedRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'assignedRolesDisplayNames': json['assignedRolesDisplayNames'] == null ? undefined : json['assignedRolesDisplayNames'],
        'reviewRequired': json['reviewRequired'] == null ? undefined : json['reviewRequired'],
        'reviewUserIds': json['reviewUserIds'] == null ? undefined : json['reviewUserIds'],
        'reviewRoleIds': json['reviewRoleIds'] == null ? undefined : json['reviewRoleIds'],
        'reviewUsers': json['reviewUsers'] == null ? undefined : ((json['reviewUsers'] as Array<any>).map(UserCatalogDtoFromJSON)),
        'reviewRoles': json['reviewRoles'] == null ? undefined : ((json['reviewRoles'] as Array<any>).map(RoleCatalogDtoFromJSON)),
        'reviewRolesDisplayNames': json['reviewRolesDisplayNames'] == null ? undefined : json['reviewRolesDisplayNames'],
        'autoApprove': json['autoApprove'] == null ? undefined : json['autoApprove'],
        'wasAutoApproved': json['wasAutoApproved'] == null ? undefined : json['wasAutoApproved'],
        'approvalTime': json['approvalTime'] == null ? undefined : json['approvalTime'],
        'approverUserId': json['approverUserId'] == null ? undefined : json['approverUserId'],
        'approverUser': json['approverUser'] == null ? undefined : HistoryDtoUserFromJSON(json['approverUser']),
        'targetSystemId': json['targetSystemId'] == null ? undefined : json['targetSystemId'],
        'targetSystem': json['targetSystem'] == null ? undefined : JobConfigurationDtoTargetSystemFromJSON(json['targetSystem']),
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'executionAllDay': json['executionAllDay'] == null ? undefined : json['executionAllDay'],
        'dueState': json['dueState'] == null ? undefined : DueStateFromJSON(json['dueState']),
        'executionStarted': json['executionStarted'] == null ? undefined : json['executionStarted'],
        'executionCompleted': json['executionCompleted'] == null ? undefined : json['executionCompleted'],
        'executionCompletedByUser': json['executionCompletedByUser'] == null ? undefined : HistoryDtoUserFromJSON(json['executionCompletedByUser']),
        'executionStateChangedTime': json['executionStateChangedTime'] == null ? undefined : json['executionStateChangedTime'],
        'executionStateChangedUser': json['executionStateChangedUser'] == null ? undefined : HistoryDtoUserFromJSON(json['executionStateChangedUser']),
        'workProgressSummary': json['workProgressSummary'] == null ? undefined : JobOccurrenceCatalogDtoWorkProgressSummaryFromJSON(json['workProgressSummary']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function JobOccurrenceCatalogDtoToJSON(value?: Omit<JobOccurrenceCatalogDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['creatorUser']),
        'lastModifierUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['lastModifierUser']),
        'editingUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': JobStateToJSON(value['state']),
        'jobConfigurationId': value['jobConfigurationId'],
        'jobConfigurationName': value['jobConfigurationName'],
        'jobConfigurationIuid': value['jobConfigurationIuid'],
        'frequency': JobFrequencyToJSON(value['frequency']),
        'assignedUserIds': value['assignedUserIds'],
        'assignedRoleIds': value['assignedRoleIds'],
        'assignedUsers': value['assignedUsers'] == null ? undefined : ((value['assignedUsers'] as Array<any>).map(UserCatalogDtoToJSON)),
        'assignedRoles': value['assignedRoles'] == null ? undefined : ((value['assignedRoles'] as Array<any>).map(RoleCatalogDtoToJSON)),
        'assignedRolesDisplayNames': value['assignedRolesDisplayNames'],
        'reviewRequired': value['reviewRequired'],
        'reviewUserIds': value['reviewUserIds'],
        'reviewRoleIds': value['reviewRoleIds'],
        'reviewUsers': value['reviewUsers'] == null ? undefined : ((value['reviewUsers'] as Array<any>).map(UserCatalogDtoToJSON)),
        'reviewRoles': value['reviewRoles'] == null ? undefined : ((value['reviewRoles'] as Array<any>).map(RoleCatalogDtoToJSON)),
        'reviewRolesDisplayNames': value['reviewRolesDisplayNames'],
        'autoApprove': value['autoApprove'],
        'wasAutoApproved': value['wasAutoApproved'],
        'approvalTime': value['approvalTime'],
        'approverUserId': value['approverUserId'],
        'approverUser': HistoryDtoUserToJSON(value['approverUser']),
        'targetSystemId': value['targetSystemId'],
        'targetSystem': JobConfigurationDtoTargetSystemToJSON(value['targetSystem']),
        'start': value['start'],
        'end': value['end'],
        'timeZone': value['timeZone'],
        'executionAllDay': value['executionAllDay'],
        'dueState': DueStateToJSON(value['dueState']),
        'executionStarted': value['executionStarted'],
        'executionCompleted': value['executionCompleted'],
        'executionCompletedByUser': HistoryDtoUserToJSON(value['executionCompletedByUser']),
        'executionStateChangedTime': value['executionStateChangedTime'],
        'executionStateChangedUser': HistoryDtoUserToJSON(value['executionStateChangedUser']),
        'workProgressSummary': JobOccurrenceCatalogDtoWorkProgressSummaryToJSON(value['workProgressSummary']),
        '$type': value['$type'],
    });
}

